import EventEmitter from "eventemitter3";

type IEvents = "on" | "once" | "off" | "emit";
type IAppEmitter = Pick<EventEmitter, IEvents>;

const eventEmitter = new EventEmitter();

export const AppEmitter: IAppEmitter = {
    on: (event, fn) => eventEmitter.on(event, fn),
    off: (event, fn) => eventEmitter.off(event, fn),
    once: (event, fn) => eventEmitter.once(event, fn),
    emit: (event, payload) => eventEmitter.emit(event, payload),
}

Object.freeze(AppEmitter);

